import { useState, useEffect, useCallback } from 'react';
import { clientService } from '../services/api';
import Navbar from '../components/Navbar';

const fmt = n => '₡' + Number(n).toLocaleString('es-CR');

export default function Clients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);
  const [search, setSearch] = useState('');

  const load = useCallback(async (s) => {
    try {
      const res = await clientService.getAll(s);
      setClients(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(''); }, [load]);

  useEffect(() => {
    const timer = setTimeout(() => load(search), 400);
    return () => clearTimeout(timer);
  }, [search, load]);

  const viewClient = async (id) => {
    try {
      const res = await clientService.getOne(id);
      setSelected(res.data);
    } catch (err) {
      alert('Error al cargar cliente');
    }
  };

  const COLORS = { 'Pendiente':'#f59e0b','En Taller':'#3b82f6','Lista':'#8b5cf6','Entregada':'#10b981' };

  const s = {
    main: { maxWidth:1100, margin:'0 auto', padding:'20px 14px' },
    card: { background:'#fff', borderRadius:10, boxShadow:'0 1px 6px rgba(0,0,0,0.09)', padding:22, marginBottom:18 },
    table: { width:'100%', borderCollapse:'collapse', fontSize:13 },
    th: { background:'#f5ede6', padding:'9px 11px', textAlign:'left', fontWeight:600, color:'#5c3d2e', borderBottom:'2px solid #e0d0c0' },
    td: { padding:'9px 11px', borderBottom:'1px solid #f0e8e0', verticalAlign:'middle' },
    btn: { background:'#f0ebe5', color:'#5c3d2e', border:'none', padding:'6px 14px', borderRadius:7, cursor:'pointer', fontSize:12 },
    overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.45)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 },
    box: { background:'#fff', borderRadius:12, padding:26, maxWidth:560, width:'90%', maxHeight:'85vh', overflowY:'auto' },
    badge: est => ({ background:COLORS[est]||'#aaa', color:'#fff', padding:'3px 8px', borderRadius:20, fontSize:11, fontWeight:600 }),
    searchBox: { width:'100%', padding:'10px 14px', border:'1px solid #ddd', borderRadius:8, fontSize:14, boxSizing:'border-box', marginBottom:14, outline:'none' },
  };

  return (
    <div style={{ fontFamily:"'Segoe UI',sans-serif", minHeight:'100vh', background:'#f8f5f0' }}>
      <Navbar />
      <div style={s.main}>
        <div style={s.card}>
          <h2 style={{ margin:'0 0 16px', color:'#5c3d2e', fontSize:18 }}>👥 Base de Clientes</h2>
          <input style={s.searchBox} placeholder="🔍 Buscar por nombre, cédula o teléfono..." value={search} onChange={e=>setSearch(e.target.value)}/>
          {loading
            ? <div style={{ color:'#aaa', textAlign:'center', padding:28 }}>Cargando clientes...</div>
            : clients.length === 0
              ? <div style={{ color:'#aaa', textAlign:'center', padding:28 }}>No se encontraron clientes.</div>
              : <div style={{ overflowX:'auto' }}>
                <table style={s.table}>
                  <thead><tr>
                    <th style={s.th}>Nombre</th>
                    <th style={s.th}>Cédula</th>
                    <th style={s.th}>Teléfono</th>
                    <th style={s.th}>Órdenes</th>
                    <th style={s.th}>Total Comprado</th>
                    <th style={s.th}>Acciones</th>
                  </tr></thead>
                  <tbody>
                    {clients.map(c => (
                      <tr key={c.id}>
                        <td style={s.td}><strong>{c.name}</strong></td>
                        <td style={s.td}>{c.cedula}</td>
                        <td style={s.td}>{c.phone1}</td>
                        <td style={s.td}>{c.total_ordenes}</td>
                        <td style={s.td}><strong style={{ color:'#10b981' }}>{fmt(c.total_comprado)}</strong></td>
                        <td style={s.td}><button style={s.btn} onClick={()=>viewClient(c.id)}>Ver historial</button></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
          }
        </div>
      </div>

      {selected && (
        <div style={s.overlay} onClick={()=>setSelected(null)}>
          <div style={s.box} onClick={e=>e.stopPropagation()}>
            <h3 style={{ margin:'0 0 16px', color:'#5c3d2e' }}>👤 {selected.name}</h3>
            {[['Cédula',selected.cedula],['Dirección',selected.address],['Teléfono 1',selected.phone1],['Teléfono 2',selected.phone2||'—']].map(([l,v])=>(
              <div key={l} style={{ display:'flex', justifyContent:'space-between', padding:'7px 0', borderBottom:'1px solid #f0e8e0', fontSize:13 }}>
                <span style={{ color:'#888', fontWeight:600 }}>{l}</span>
                <span style={{ fontWeight:600 }}>{v}</span>
              </div>
            ))}
            <h4 style={{ margin:'16px 0 10px', color:'#5c3d2e' }}>Historial de Órdenes</h4>
            {selected.ordenes?.length === 0
              ? <div style={{ color:'#aaa', fontSize:13 }}>Sin órdenes.</div>
              : selected.ordenes?.map(o => (
                <div key={o.id} style={{ background:'#fdf8f4', borderRadius:8, padding:10, marginBottom:8, fontSize:13 }}>
                  <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4 }}>
                    <strong style={{ color:'#a0522d' }}>{o.numero}</strong>
                    <span style={s.badge(o.status)}>{o.status}</span>
                  </div>
                  <div style={{ color:'#666' }}>{o.article} — {fmt(Number(o.amount)+Number(o.shipping))}</div>
                  <div style={{ color:'#aaa', fontSize:11 }}>Vendedor: {o.vendedor} · {o.order_date?.split('T')[0]}</div>
                </div>
              ))
            }
            <button style={{ background:'#5c3d2e', color:'#fff', border:'none', padding:'10px', borderRadius:8, cursor:'pointer', fontSize:14, fontWeight:600, width:'100%', marginTop:16 }} onClick={()=>setSelected(null)}>Cerrar</button>
          </div>
        </div>
      )}
    </div>
  );
}
